import axios from "axios";

const server = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: { 'Content-Type': 'application/json' }
})

export class UberDirectFetchAPI {

    //Function to get Uber Direct quote order 
    static async getUberDirectQuoteOrder(token, data){
        const res = await server(`/quote/uberdirect`, {
            method: "post",
            headers: { 'x-access-token': token },
            data: data,
        });
        return res;
    }

   //Function to register the Uber Direct order
    static async registerUberDirectOrder(token, data){
        const res = await server(`/order/uberdirect`, {
            method: "post",
            headers: { 'x-access-token': token },
            data: data,
        });
        return res;
    }

    //Function to get Uber Direct order details
    static async getUberDirectOrderDetails(token, business_id, rider_order_id){
        const res = await server(`/order/uberdirect?business_id=${business_id}&rider_order_id=${rider_order_id}`, {
            method: "get",
            headers: { 'x-access-token': token },
        });
        return res;
    }
}